import { render } from "./configItem.vue?vue&type=template&id=57ce8230&scoped=true"
import script from "./configItem.vue?vue&type=script&lang=js"
export * from "./configItem.vue?vue&type=script&lang=js"

import "./configItem.vue?vue&type=style&index=0&id=57ce8230&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ce8230"]])

export default __exports__